import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const lakeShapeApi = createApi({
    reducerPath: "core/lake/shape",
    baseQuery: axiosBaseQuery,
    tagTypes: ["lakeList"],
    endpoints: (builder) => ({
        lakeShapeFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['lakeList'],
            query: (query = '') => ({
                url: "core/nuur" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
     
        lakeShapeUpdate: builder.mutation({
            invalidatesTags: ['lakeList'],
            // query: (data)=>({url: "/core/lake/"+data.id, method: "PUT", data})
            query: (data) => ({
                url: `core/nuur/${data.get('id')}`,
                method: "PUT",
                data,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
        }),

    })
})

export const { useLakeShapeFindAllQuery, useLakeShapeUpdateMutation } = lakeShapeApi;
export { lakeShapeApi };
